import { RemixiconComponentType } from '@remixicon/react';

export const IconBusiness: RemixiconComponentType = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <path d="M5.414 2H0v20h24V3h-9v7H9V5.586L5.414 2zM15 12v8H9v-8h6zm2 8V5h5v15h-5zM7 20H2V4h2.586L7 6.414V20z" />
  </svg>
);
